import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["drawer", "button"]

  connect() {
    this.closeOnNavigate = () => this.close()
    document.addEventListener("turbo:before-visit", this.closeOnNavigate)
  }

  disconnect() {
    document.removeEventListener("turbo:before-visit", this.closeOnNavigate)
  }

  toggle() {
    const open = this.buttonTarget.getAttribute("aria-expanded") === "true"
    this.setOpen(!open)
  }

  close() {
    this.setOpen(false)
  }

  setOpen(open) {
    this.drawerTarget.hidden = !open
    this.buttonTarget.setAttribute("aria-expanded", String(open))
    this.element.classList.toggle("site-header--menu-open", open)
  }
}
